// For fields with an autofocus attribute, the cursor will be placed at the start by default when the field is auto-focused.
// This compiler moves the caret to the end of the field which comes in handy for fields that are already filled upon
// initial page load.

up.compiler('input[autofocus], textarea[autofocus]', (field) => {

  // Use a slight delay to ensure autofocus has been applied
  setTimeout(() => {
    // Run only if the field has the autofocus attribute and is currently focused
    if (document.activeElement === field && field.value.length > 0) {
      // Set the caret position to the end of the field value
      field.setSelectionRange(field.value.length, field.value.length);
    }
  }, 0);
});
